/** The app shell's own handoff/loading screen (ClimbJobs App.dc.html's "Setting up your editor…" surface). */
import React, { Suspense, lazy } from 'react';
import { useIsAndroidApp } from '../lib/platform';

// The Android app's brand loader (android-polish ticket 05); a browser keeps the spinner and loads none of it.
const BrandLoader = lazy(() => import('../android/assets/Marks').then((m) => ({ default: m.BrandLoader })));

export function FullPageLoader({ label, sub, error }: { label: string; sub?: string; error?: boolean }) {
  const app = useIsAndroidApp();
  const spinner = <span aria-hidden="true" style={{ width: 46, height: 46, borderRadius: '50%', border: '4px solid #e5e3ec', borderTopColor: 'var(--accent, #0f8a80)', animation: 'cj-spin 1s linear infinite' }} />;
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 80, background: app ? 'var(--app-canvas, #eef1f6)' : '#eef1f6', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, fontFamily: 'Inter,ui-sans-serif,system-ui,sans-serif' }}>
      {error ? (
        <span aria-hidden="true" style={{ width: 46, height: 46, borderRadius: '50%', background: '#fdeff1', color: '#b23b47', display: 'grid', placeItems: 'center', fontSize: 22, fontWeight: 800 }}>!</span>
      ) : app ? (
        <Suspense fallback={null}><BrandLoader size={56} label={label} /></Suspense>
      ) : spinner}
      <div style={{ fontSize: 16, fontWeight: 700, color: '#141923' }}>{label}</div>
      {sub ? <div style={{ fontSize: 13, color: '#767a8b' }}>{sub}</div> : null}
    </div>
  );
}
